module.exports = __webpack_public_path__ + "static/media/chevron-left.e9019515.svg";